import React from "react";
import "./Skeleton.css";

type SkeletonProps = {
  width?: string;
  height?: string;
  borderRadius?: string;
  className?: string;
};

export function Skeleton({
  width = "100%",
  height = "16px",
  borderRadius = "8px",
  className,
}: SkeletonProps) {
  return (
    <div
      className={`oht-skeleton${className ? ` ${className}` : ""}`}
      style={{ width, height, borderRadius }}
    />
  );
}

/** KPI tile skeleton — mirrors the OHT KPI tile layout. */
export function SkeletonKpiTile() {
  return (
    <div className="oht-skeleton-kpi">
      <Skeleton width="60%" height="12px" />
      <Skeleton width="50%" height="30px" />
      <Skeleton width="80%" height="11px" />
    </div>
  );
}

/** Donut card skeleton with a circular placeholder and 3 legend rows. */
export function SkeletonDonut() {
  return (
    <div className="oht-skeleton-donut">
      <Skeleton width="50%" height="12px" />
      <div className="oht-skeleton-donut-body">
        <div className="oht-skeleton-donut-ring" />
        <div className="oht-skeleton-donut-legend">
          <Skeleton width="70%" height="11px" />
          <Skeleton width="55%" height="11px" />
          <Skeleton width="80%" height="11px" />
        </div>
      </div>
    </div>
  );
}

/** Bar chart skeleton — 12 bars of varying heights. */
export function SkeletonChart({ height = 200 }: { height?: number }) {
  const heights = [48, 62, 75, 58, 70, 82, 77, 60, 50, 45, 55, 65];
  return (
    <div className="oht-skeleton-chart" style={{ height }}>
      {heights.map((h, i) => (
        <div
          key={i}
          className="oht-skeleton-chart-bar"
          style={{ height: `${h}%` }}
        />
      ))}
    </div>
  );
}

/** Table skeleton — header row + N body rows. */
export function SkeletonTable({
  rows = 6,
  cols = 6,
}: {
  rows?: number;
  cols?: number;
}) {
  return (
    <div className="oht-skeleton-table">
      <div className="oht-skeleton-table-header">
        {Array.from({ length: cols }).map((_, i) => (
          <Skeleton key={i} width="70%" height="11px" />
        ))}
      </div>
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} className="oht-skeleton-table-row">
          {Array.from({ length: cols }).map((_, c) => (
            <Skeleton
              key={c}
              width={c === 0 ? "80%" : c === 1 ? "70%" : "50%"}
              height="13px"
            />
          ))}
        </div>
      ))}
    </div>
  );
}
